"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@lingui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _utils = require("../../utils");

var _Exporter = require("../../../../components/Exporter");

var _store = require("../../../../redux/store");

const StyledThird = (0, _styledComponents.default)(_blocks.Thirds)`
  width: 100%;
`;

const GroupFooter = ({
  moreCount,
  currentCount,
  totalCount,
  onLoadMore,
  onLoadAll,
  exportData,
  viewMode
}) => {
  const projects = (0, _store.useAppSelector)(state => {
    var _state$auth$user$port, _state$auth$user, _state$auth$user$port2;

    return Object.values((_state$auth$user$port = (_state$auth$user = state.auth.user) === null || _state$auth$user === void 0 ? void 0 : (_state$auth$user$port2 = _state$auth$user.portfolio) === null || _state$auth$user$port2 === void 0 ? void 0 : _state$auth$user$port2.projects) !== null && _state$auth$user$port !== void 0 ? _state$auth$user$port : {});
  }); // Manually override the projectId property to support creating exports with
  // links to HV over Skyspark. This isn't supported by the ComposedInsight
  // shape as there are many places to change that and it's not worth it at this
  // stage in Bonfire's development.

  const transformedExportData = (0, _react.useMemo)(() => {
    return exportData === null || exportData === void 0 ? void 0 : exportData.map(item => {
      const project = projects.find(project => project.project_name === item.project);
      return { ...item,
        projectId: project === null || project === void 0 ? void 0 : project.project_pk
      };
    });
  }, [exportData]);
  return /*#__PURE__*/_react.default.createElement(StyledThird, null, /*#__PURE__*/_react.default.createElement(_blocks.Left, null, /*#__PURE__*/_react.default.createElement("span", null, _core.i18n._({
    id: 'show_more_grouped_rows.showing_count',
    message: `Showing {currentCount} of {totalCount}`,
    values: {
      currentCount,
      totalCount
    }
  }))), /*#__PURE__*/_react.default.createElement(_blocks.Center, null, /*#__PURE__*/_react.default.createElement(_blocks.ControlGroup, {
    tight: true
  }, currentCount < totalCount && /*#__PURE__*/_react.default.createElement(_blocks.Button, {
    appearance: "outline",
    primary: true,
    thin: true,
    onClick: onLoadMore
  }, _core.i18n._({
    id: 'show_more_grouped_rows.show_more',
    message: `Show More`
  }), ' ', "(+", moreCount, ")"), currentCount < totalCount && /*#__PURE__*/_react.default.createElement(_blocks.Button, {
    appearance: "plain",
    primary: true,
    thin: true,
    onClick: onLoadAll
  }, _core.i18n._({
    id: 'show_more_grouped_rows.show_all',
    message: `Show All`
  }), ' ', "(", totalCount, ")"))), /*#__PURE__*/_react.default.createElement(_blocks.Right, null, viewMode === 'insights' && exportData && /*#__PURE__*/_react.default.createElement(_Exporter.Exporter, {
    "data-cy": "export-insight-list",
    appearance: "outline",
    rawData: transformedExportData,
    fileName: "Grouped-Insights.csv",
    dataFormatter: _utils.getGroupedInsightsExportData,
    exportType: "insight"
  }, "Export List")));
};

var _default = GroupFooter;
exports.default = _default;
module.exports = exports.default;